import { Play } from "lucide-react"

import { cn } from "@/shared/lib/utils"

export function VideoAutoplayFallback({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "pointer-events-none absolute inset-0 z-20 flex items-center justify-center bg-black/15",
        className
      )}
    >
      <span className="flex size-11 items-center justify-center rounded-full border border-white/60 bg-black/55 text-white shadow-lg backdrop-blur-sm">
        <Play className="ml-0.5 size-5 fill-current" />
      </span>
    </div>
  )
}
